import { useConfirmationDialog } from '@goodfynd/ui';
import { useSubscriptionApi } from '@hooks/api/account/useSubscriptionApi/useSubscriptionApi';
import { usePostApi } from '@hooks/api/usePostApi';
import type {
  ActiveSubscriptionItem,
  SubscriptionCancel,
} from 'types/account/subscriptions';
import type { PostApiOptions } from 'types/api';

export function useUncancelSubscription(
  organizationId: string,
  options?: Partial<PostApiOptions<ActiveSubscriptionItem, SubscriptionCancel>>
) {
  const api = useSubscriptionApi();
  const { getConfirmation } = useConfirmationDialog();

  const { post: uncancelSubscription, isPosting: isUncancelingSubscription } =
    usePostApi({
      getSuccessMessage: () => 'Subscription restored!',
      request: (params) => api.cancelSubscription(organizationId, params),
      ...options,
    });

  return {
    isUncancelingSubscription,
    uncancelSubscription: async (item: ActiveSubscriptionItem) => {
      if (
        !(await getConfirmation({
          title: 'Restore subscription',
          message: `Are you sure you want to restore your previous plan?`,
          confirmButtonText: 'Yes, restore',
        }))
      ) {
        return;
      }

      return uncancelSubscription({
        subscriptionId: item.stripeId,
      });
    },
  };
}
